export const HomePic = ({ navigate }) => {
    return (
        <div className="home-pic">
            <div className="home-bg-box">
                <div className="home-cap">
                    STEM Learning for every pathfinder
                </div>
                <div className="home-descr">
                    Accessible hands-on digital STEM education for all
                </div>
                <div className="start-prompt">
                    <button className="home-start" onClick={navigate}>
                        Get Started
                    </button>
                    <span className="home-descr">Explore courses</span>
                </div>
            </div>
        </div>
    )
}